import React, { FC } from 'react';

import { Box, BoxProps } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
interface RadioIndicatorProps extends BoxProps {
  isSelected: boolean;
  isDisabled?: boolean;
}

export const RadioIndicator: FC<RadioIndicatorProps> = ({
  isSelected,
  isDisabled,
  ...boxProps
}) => {
  return (
    <Box
      width="$5"
      height="$5"
      borderRadius="full"
      backgroundColor={
        isDisabled
          ? getDesignToken('background-input-disabled')
          : getDesignToken('background-input')
      }
      borderWidth={isSelected ? 5 : 1}
      borderColor={isSelected ? primitive.$bbqBrown : primitive.$greyTwo}
      {...boxProps}
    />
  );
};

export default RadioIndicator;
